import React from "react";
import heroImg from "../../assets/policies/heroImg.webp";

const TermsAndConditions = () => {
  return (
    <section
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-once="true"
      className="relativept-24 md:pt-32 lg:pt-28 pb-4 md:pb-4 lg:pb-8 
                        px-4 md:px-8 lg:px-12 
                        bg-[#070021] text-white 
                        font-poppins tracking-widest"
    >
      {/* Left Blur  */}
      <div
        className="absolute left-0 top-0 w-[40%] h-[40%] rounded-full 
                           bg-[#1a99c03b] blur-[100px] md:blur-[140px] lg:blur-[180px] 
                           z-0"
      ></div>

      {/* Right Blur */}
      <div
        className="absolute right-0 top-0 w-[45%] h-[45%] rounded-full 
                           bg-[#1a99c03b] blur-[120px] md:blur-[160px] lg:blur-[200px] 
                           z-0"
      ></div>
      <div className="absolute top-0 -right-12 w-[40%]">
        <img
          src={heroImg}
          alt="Hero Background"
          className="inset-0 w-[100%] h-full object-cover "
          loading="eager"
          fetchpriority="high"
        />
      </div>
      <div className="max-w-[95%] mx-auto ">
        <h1 className="text-3xl md:text-4xl lg:text-3xl font-semibold mb-8">
          Terms & Conditions
        </h1>

        <div className="text-sm md:text-base lg:text-[14px] leading-relaxed mb-1">
          Updated On: <span className="text-[#49D093]">October 2023</span>
        </div>

        <div
          className="h-[0.8px] w-full mb-8 
                        bg-gradient-to-r from-[#49D093] via-[#38b87eef] to-[#0C226E]"
        />

        {/* Acceptance of Terms */}
        <div data-aos="fade-up" data-aos-duration="1000" data-aos-once="true">
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 text-[#49D093]"
          >
            Acceptance of Terms
          </h2>

          <p
            className="text-[10px] md:text-[12px] lg:text-[12px] 
                        font-extralight ml-2 mb-4 leading-relaxed"
          >
            By accessing this website, you agree to these Terms & Conditions
            (“Terms”). If you do not agree, please refrain from using the site.
          </p>
        </div>

        {/* Use of Content */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="100"
          className="mt-5 lg:w-[85%]"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 text-[#49D093]"
          >
            Use of Content
          </h2>
          <p
            className="text-[10px] md:text-[12px] lg:text-[12px] 
                        font-extralight ml-2 mb-4 leading-relaxed"
          >
            All content on this site – including text, graphics, logos, images,
            and documents – is owned by Mark9 Solutions  and protected by
            copyright and trademark laws. You may view or download content for
            informational, non-commercial use only. Any modification or
            redistribution requires written consent.
          </p>
        </div>

        {/* No Warranties */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="200"
          className="mt-5 lg:w-[85%]"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 text-[#49D093]"
          >
            No Warranties
          </h2>

          <p className="text-[10px] md:text-[12px] lg:text-[12px] font-extralight ml-2 mb-4 leading-relaxed">
            While we strive for accuracy, information is provided “as is”
            without warranty of any kind. Mark9 Pte. Ltd. disclaims all
            liability for errors or omissions or for actions taken in reliance
            on site content.
          </p>
        </div>

        {/* Third-Party Links */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="300"
          className="mt-5"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 text-[#49D093]"
          >
            Third-Party Links
          </h2>
          <p className="text-[10px] md:text-[12px] lg:text-[13px] font-extralight mb-2 ml-2 md:ml-2">
            This website may contain links to third-party sites. We are not
            responsible for their content or privacy practices.
          </p>
        </div>

        {/* Limitation of Liability */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="400"
          className="mt-5 lg:w-[85%]"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 text-[#49D093]"
          >
            Limitation of Liability
          </h2>

          <p className="text-[10px] md:text-[12px] lg:text-[13px] font-extralight mb-2 ml-2 md:ml-2">
            To the maximum extent permitted by law, Mark9 Pte. Ltd. shall not be
            liable for any indirect, incidental, or consequential damages
            arising from use of this site or its content.
          </p>
        </div>

        {/* Indemnification */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="500"
          className="mt-5"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 text-[#49D093]"
          >
            Indemnification
          </h2>

          <p className="text-[10px] md:text-[12px] lg:text-[13px] font-extralight mb-2 ml-2 md:ml-2">
            You agree to indemnify and hold Mark9 Solutions harmless from any
            claims resulting from your violation of these Terms.
          </p>
        </div>

        {/* Governing Law */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="600"
          className="mt-5"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 text-[#49D093]"
          >
            Governing Law
          </h2>

          <p className="text-[10px] md:text-[12px] lg:text-[13px] font-extralight mb-2 ml-2 md:ml-2">
            These Terms shall be governed by and construed in accordance with
            the laws of Singapore, without regard to conflict-of-law principles.
          </p>
        </div>

        {/* Changes to Terms */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="700"
          className="mt-5"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 text-[#49D093]"
          >
            Changes to Terms
          </h2>

          <p className="text-[10px] md:text-[12px] lg:text-[13px] font-extralight mb-2 ml-2 md:ml-2">
            Mark9 Solutions may update these Terms at any time. Continued use of
            the website constitutes acceptance of the revised Terms.
          </p>
        </div>

        {/* Contact Us */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="800"
          className="mt-5"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 text-[#49D093]"
          >
            Contact Us
          </h2>

          <p className="text-[10px] md:text-[12px] lg:text-[13px] font-extralight mb-1 ml-2 md:ml-2 text-[#49D093]">
            Mark9 Pte. Ltd.
          </p>
          <p className="text-[10px] md:text-[12px] lg:text-[12px] font-extralight mb-2 ml-2 md:ml-2">
            10 Anson Road <br />
            #30-18 Singapore 079903 <br />
            UEN# 201023310E <br />
            <span className="text-[#49D093]">
              privacy@m9-solutions.com | www.m9-solutions.com
            </span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default TermsAndConditions;
